"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return ValueValidators;
    }
});
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var ValueValidators = /*#__PURE__*/ function() {
    "use strict";
    function ValueValidators() {
        _classCallCheck(this, ValueValidators);
    }
    ValueValidators.validate = function validate(paramInfo, value) {
        if (paramInfo.skipValueValidation || paramInfo.format === undefined) return true;
        return ValueValidators.formatToValidatorMapping[paramInfo.format](paramInfo, value);
    };
    ValueValidators.isValueOneOfList = function isValueOneOfList(paramInfo, value) {
        return paramInfo.values.includes(value);
    };
    ValueValidators.isValueWithinBounds = function isValueWithinBounds(paramInfo, value) {
        return (paramInfo.minimum === undefined || value >= paramInfo.minimum) && (paramInfo.maximum === undefined || value <= paramInfo.maximum);
    };
    ValueValidators.arrayValidation = function arrayValidation(paramInfo, value) {
        // No value validation so far.
        return true;
    };
    return ValueValidators;
}();
ValueValidators.formatToValidatorMapping = {
    oneOf: ValueValidators.isValueOneOfList,
    float: ValueValidators.isValueWithinBounds,
    array: ValueValidators.arrayValidation
};
